// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--svCrn","promo-icon":"_0fce717cdb--promo-icon--ToDBR","promo-link":"_0fce717cdb--promo-link--Rlk7f"};